"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventVisibilities = void 0;
require("firebase/auth");
exports.EventVisibilities = {
    Public: "public",
    Private: "private",
};
// TODO how to ensure this is only included in server side bundle?
// export const activityRef = (
//   activityId: string
// ): FirebaseFirestore.DocumentReference =>
//   admin.firestore().doc(`/activities/${activityId}`);
// export const fetchActivity = async (activityId: string): Promise<Event> =>
//   await activityFromRef(activityRef(activityId));
// export const activityFromRef = async (
//   ar: FirebaseFirestore.DocumentReference
// ): Promise<Event> => ({ ...(await ar.get()).data(), id: ar.id } as Event);
// TODO add types and test this
// type GooglePlace = any;
// export const fetchGooglePlace = async (
//   googlePlaceId: string
// ): Promise<GooglePlace> => {
//   // fetch the google place data and merge it in to the activity
//   const url = `${baseUrl()}/api/place`;
//   console.log("fetching google place", url, googlePlaceId);
//   return axios.get(url, { params: { id: googlePlaceId } }).then(({ data }) => {
//     console.log({ googlePlaceData: data });
//     return {
//       googlePlaceData: data,
//     };
//   });
// };
//# sourceMappingURL=Event.js.map